import React from "react";
import {
    Field,
    reduxForm,
} from "redux-form";
import FormField from "@/components/forms/form-field";
import OneAutocompleteField from "@/components/forms/one-autocomplete";
import {phonePattern} from '@/utils/forms.js';
import {FORMS} from "@/static/common";
import validateStep1 from './reviewStep1Validation';


const ReviewStep1 = ({handleSubmit, submitting, onSubmit}) => {
 return (
     <form onSubmit={handleSubmit(onSubmit)} className="form-layout" noValidate>
         <div className="form-row">
             <div className="form-col_2">
                 <Field
                     name="firstname"
                     component={FormField}
                     required
                     type="text"
                     label="First Name"
                 />
             </div>
             <div className="form-col_2">
                 <Field
                     name="lastname"
                     component={FormField}
                     required
                     type="text"
                     label="Last Name"
                 />
             </div>
         </div>
         <div className="form-row">
             <div className="form-col_2">
                 <Field
                     name="phone"
                     component={FormField}
                     required
                     type="text"
                     {...phonePattern}
                     label="Phone Number"
                 />
             </div>
             <div className="form-col_2">
                 <Field
                     name="email"
                     component={FormField}
                     required
                     type="email"
                     label="Email Address"
                 />
             </div>
         </div>
         <Field
             name="company_name"
             component={FormField}
             required
             type="text"
             label="Company Name"
         />
         <Field
             name="label"
             component={OneAutocompleteField}
             required={true}
             type="text"
             url="clear/label/search"
             placeholder={FORMS.PLACEHOLDER_TBD}
             label="Name of your Label"
         />
         <div className="submit-row_txt">
             <button
                 type="submit"
                 className="btn-red-primary"
                 disabled={submitting}
             >
                 Next
             </button>
         </div>
     </form>
 )
}

export default reduxForm({
    form: 'sampleReviewStep1',
    validate: validateStep1,
    enableReinitialize: true,
})(ReviewStep1);
